export const users = state => state.users
export const internalUsers = state => state.users.filter(user => ['admin'].includes(user.role))
